// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const Search = (): React.Element<*> => (
  <path d="M17.856 17.146l-5.272-5.271c0.882-1.035 1.418-2.387 1.418-3.865 0-0.003 0-0.007 0-0.010v0.001c0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c0.003 0 0.006 0 0.009 0 1.478 0 2.831-0.537 3.874-1.425l-0.008 0.007 5.272 5.272c0.090 0.090 0.215 0.146 0.354 0.146 0.276 0 0.5-0.224 0.5-0.5 0-0.138-0.056-0.263-0.146-0.354v0zM3.002 8c0-2.761 2.239-5 5-5s5 2.239 5 5-2.238 5-5 5-5-2.239-5-5z"></path>
);
